// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarOsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/os/migrar-todas
 * (controllers/migration/os.php::migrar_todas).
 *
 * O fechamento da carga da cadeia da OS de UMA franquia num periodo: o run do
 * lote, a contabilidade dos quatro desfechos (MigrationTally — `bloqueadas`
 * NAO entra em `falhas`), o que o proprio Zoho nao conseguiu exportar, e o
 * desfecho de cada linha das QUATRO listas.
 *
 * `migradas + skipped + bloqueadas + falhas == total`, sempre — e `total` aqui
 * conta as quatro listas juntas (OS, itens, adicionais e produtos), que e o
 * que a barra de progresso da tela mede.
 *
 * `por_tipo` existe porque a soma sozinha mente: um lote em que TODAS as OS
 * entraram e TODOS os itens falharam mostra "50% migradas" e parece meio bom,
 * quando na verdade nenhuma OS tem par nenhum. O recorte por lista poe isso
 * na cara do operador.
 */
import type { Migration_OsResultadoRow } from './Migration_OsResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarOsResponseDados {
run_id: number
total: number
migradas: number
skipped: number
bloqueadas: number
falhas: number
por_tipo: Record<string, Record<string, number>>
erros_zoho: string[]
resultados: Migration_OsResultadoRow[]
}

export type Migration_MigrarOsResponse = ApiResponse<Migration_MigrarOsResponseDados>;

registerResponseContract('Migration_MigrarOsResponse', {
  run_id:     { type: 'number',  required: true },
  total:      { type: 'number',  required: true },
  migradas:   { type: 'number',  required: true },
  skipped:    { type: 'number',  required: true },
  bloqueadas: { type: 'number',  required: true },
  falhas:     { type: 'number',  required: true },
  por_tipo:   { type: 'object',  required: true },
  erros_zoho: { type: 'array',   required: true },
  resultados: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      run_id:         { type: 'number',  required: false },
      linha_local_id: { type: 'number',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      erro:           { type: 'string',  required: false },
    },
  },
})
